export default __webpack_public_path__ + "static/media/avatar_tapir1.fce4e7a5.mp3";